import React, { useRef } from 'react';
import { Grid, Button } from '@material-ui/core';
import { observer } from 'mobx-react';
import ManufactureWork from '../../../../../data/model/manufacture/ManufactureWork';
import ReactToPrint from 'react-to-print';
import PrintManufactureRequestComponent from './print/PrintManufactureRequestComponent';
import PrintManufactureShippingConfirmComponent from './print/PrintManufactureShippingConfirmComponent';
import { CSVLink } from 'react-csv';
import { GetApp } from '@material-ui/icons';
import dayjs from 'dayjs';
import ManufactureItem from '../../../../../data/model/manufacture/ManufactureItem';
// import Helper from '../../../../../module/Helper';

interface Props {
    data?: ManufactureWork;
    isLoaded?: boolean;
    requestPrintable?: boolean;
    shippingPrintable?: boolean;
}

const ManufacturePrintComponent: React.FC<Props> = observer((props) => {
    const withOEMName = props.data?.withOEMItemName ?? ((name) => name)
    const loaded = props.isLoaded || false;
    const requestRef = useRef();
    const shippingRef = useRef();

    const requestPrintable = props.requestPrintable || false;
    const shippingPrintable = props.shippingPrintable || false;

    return (
        <React.Fragment>
            <Grid container style={{ marginBottom: 15 }}>
                <Grid item xl lg md sm>
                    <ReactToPrint
                        trigger={() =>
                            <Button
                                disabled={!loaded || !requestPrintable}
                                color='primary'
                                variant='contained'
                                style={{ marginRight: 10 }}>
                                제조의뢰서 출력
                            </Button>
                        }
                        content={() => requestRef.current}
                        documentTitle={props.data?.erpCode ? `제조의뢰서_${props.data.erpCode}` : '제조의뢰서'}
                    />
                    <ReactToPrint
                        trigger={() =>
                            <Button
                                disabled={!loaded || !shippingPrintable}
                                color='primary'
                                variant='contained'
                                style={{ marginRight: 10 }}>
                                출하확인서 출력
                            </Button>
                        }
                        content={() => shippingRef.current}
                        documentTitle={props.data?.erpCode ? `출하확인서_${props.data.erpCode}` : '출하확인서'}
                    />
                    <CSVLink
                        data={props.data.itemList?.slice().sort((a, b) => b.boxNO.localeCompare(a.boxNO, undefined, { numeric: true })).map((v, i) => {
                            return {
                                '#': i + 1,
                                'Project Code (ERP)': props.data?.erpCode,
                                'Box No.': v.boxNO,
                                'Items': withOEMName(v.packagingListItemName, v.itemOptions.version),
                                'Cat No.': v.manipulatedCatNO ? (props.data?.withOEMPrefixCatNo ? props.data.withOEMPrefixCatNo(v.manipulatedCatNO, v.itemOptions.version) : v.manipulatedCatNO) : '',
                                'Lot No.': v.lotNO ? (props.data?.concatCatNoAndLotNo ? props.data.concatCatNoAndLotNo(v.manipulatedCatNO, v.lotNO, v.itemOptions.version) : v.lotNO) : v.lotNO,
                                'Q\'ty': v.qty,
                                'StorageTemp': (ManufactureItem.StorageTempList as any)[v.storageTemp],
                                'Remark': v.remark,
                                'ProbeID': v.probeID,
                                'Options': v.itemOptions.getPackgingOptionsString(),
                                'ShippingCondition': (ManufactureItem.ShippingCoditionList as any)[v.shippingCondition],
                                'Exp. Date': v.expDate ? dayjs(v.expDate).format('YYYY-MM-DD') : '',
                                // 'Unit Q\'ty': v.numberPerQty,
                                // 'Unit': v.unit,
                                // 'Pooling': v.pooling,
                            }
                        })}
                        filename={`PackingList_${props.data.erpCode}`}
                        onClick={() => {
                            if (props.data.itemList.length < 1) {
                                return false;
                            }
                        }}
                        style={{
                            textDecoration: 'none'
                        }}
                    >
                        <Button
                            disabled={props.data.itemList.length < 1}
                            color='primary'
                            variant='contained'
                            style={{ marginRight: 10 }}>
                            패킹 리스트
                            <GetApp />
                        </Button>
                    </CSVLink>
                </Grid>
            </Grid>
            <div style={{ display: 'none' }}>
                <PrintManufactureRequestComponent data={props.data} ref={requestRef} />
                <PrintManufactureShippingConfirmComponent data={props.data} ref={shippingRef} />
            </div>
        </React.Fragment>
    )
})

export default ManufacturePrintComponent;
